import React from "react";
import { Helmet } from "react-helmet";
import Header from "./components/Header/Header";
import Hero from "./components/Hero/Hero";
import ConsumerAffairsLogo from "./components/ConsumerAffairs/ConsumerAffairsLogo";
import Footer from "./components/Footer/Footer";
import Learn from "./components/Learn/Learn";
import WhyClayton from "./components/WhyClayton/WhyClayton";
import "./App.css";

const ConsumerAffairs = () => {
  return (
    <>
      <Helmet htmlAttributes={{ lang: 'en' }} >
        <title>Clayton Homes: Consumer Affairs</title>
        <meta name="description" content="Clayton Homes Consumer Affairs" />
        <meta name="keywords" content="clayton homes, maryville, tennessee, consumer affairs" />
        <meta name="robots" content="nofollow" />
        <link rel="canonical" href="https://www.claytonhomes.com/pages/consumer-affairs/" />
      </Helmet>
      <Header />
      <Hero />
      <ConsumerAffairsLogo />
      <WhyClayton />
      <Learn />
      <Footer />
    </>
  );
}

export default ConsumerAffairs;
